import {RELEASE_BUNDLE_CONSTANTS} from '../../../constants/releaseBundle.constants';
/**
 * Created by aviranb on 26/12/2017.
 */
import Model from '../Model';

const ARTIFACTROY_RELATIVE_TREE_PATH = 'ui/repos/tree/General';

export default class ArtifactBundleModel extends Model {
	constructor(data) {
		super(data);
		if (data) {
			this.sourcePath = data.sourcePath;
			this.targetPath = data.targetPath;
			this.checksum = data.checksum;
			this.properties = Object.keys(data.properties).map((prop) => {
				return {key: prop, values: data.properties[prop]};
			});
			this.fileName = data.fileName;
			this.type = data.type.toLowerCase();
			this.packageName = RELEASE_BUNDLE_CONSTANTS.defaultPackageName;
			if (this.type.toLowerCase() === 'docker' && data.packageName) {
				this.packageName = data.packageName;
			}
			this.fileSize = data.fileSize;
			this.xray_status = data.xrayScanInfo || null;
			if (this.sourcePath) {
				this.artifactory_url = `/${ARTIFACTROY_RELATIVE_TREE_PATH}/${encodeURIComponent(this.sourcePath)}`;
			}
			// Artifactory unique props
            this.created = data.created;
		}
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/ArtifactBundleModel.js